import { APIListingLocationPreview, UIListingLocation } from "features/Dealers/Listings/GMBPreview/state/types"
import _ from "lodash"
import { format, parseISO } from "date-fns";

export const parseAPIListingPreview = (apiLP: APIListingLocationPreview): UIListingLocation => {
    return {
        name: apiLP.dealername ?? "",
        categories: apiLP.categories.map(c => ({
            id: c,
            name: c
        })),
        address: `${apiLP.streetaddress},${apiLP.citystatezipcode}`,
        serviceAreas: apiLP.serviceareas?.map(sa => ({ id: sa, name: sa })),
        phone: apiLP.phone,
        hoursOfOperation: apiLP.hoursofoperation?.
            map(hop => ({ day: hop.day, hours: hop.schedule }))?.
            sort((a, b) => DAYS_ORDER.indexOf(_.upperCase(a.day)) - DAYS_ORDER.indexOf(_.upperCase(b.day))),
        website: apiLP.website,
        appointmentURL: apiLP.appointmenturl,
        menuURL: apiLP.menuurl,
        orderLink: apiLP.placeorderlink,
        description: apiLP.description,
        services: apiLP.services?.map(s => ({ id: s, name: s })),
        dateOpened: apiLP.dateopened,
        urlImages: apiLP.urlimages,
        street:  apiLP.streetaddress,
        city: apiLP.city,
        state: apiLP.state,
        zipcode: apiLP.zipcode,
        country: apiLP.country
        
    }
}

export const DAYS_OF_THE_WEEK = {
    MONDAY: "MONDAY",
    TUESDAY: "TUESDAY",
    WEDNESDAY: "WEDNESDAY",
    THURSDAY: "THURSDAY",
    FRIDAY: "FRIDAY",
    SATURDAY: "SATURDAY",
    SUNDAY: "SUNDAY",
}
export const DAYS_ORDER = [
    DAYS_OF_THE_WEEK.MONDAY,
    DAYS_OF_THE_WEEK.TUESDAY,
    DAYS_OF_THE_WEEK.WEDNESDAY,
    DAYS_OF_THE_WEEK.THURSDAY,
    DAYS_OF_THE_WEEK.FRIDAY,
    DAYS_OF_THE_WEEK.SATURDAY,
    DAYS_OF_THE_WEEK.SUNDAY,
]

export const parseStringDateToDate = (dateStr?: string) => {
    if (dateStr) {
        const dateComponents = dateStr.split("-");
        const year = parseInt(dateComponents[0])
        const month = parseInt(dateComponents[1])
        const day = parseInt(dateComponents[2]=='undefined'?'01':dateComponents[2]);
        const dateSanitized = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
        const dateCreated = parseISO(dateSanitized);
        return format(dateCreated, "LLLL do, yyyy")
    }
    return ""
}
